import { RouteConfigType, setRoutesConfigAction } from './types';

export const SET_ROUTES_CONFIG = 'SET_ROUTES_CONFIG';

export const setRoutesConfig = (
  payload: RouteConfigType,
): setRoutesConfigAction => {
  return {
    type: SET_ROUTES_CONFIG,
    payload,
  };
};
